import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../../../../config/config.service';
import { AbastecimentoLubrificante } from '../../../../types/AbastecimentoLubrificante.type';
import { Page } from '../../../../types/Page.type';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root'
})
export class AbastecimentosLubrificantesService {

  constructor(private configService: ConfigService, private httpClient: HttpClient) { }

  getApontamentos(page: number, size: number, filtro?: string, modulo?: string): Observable<Page<AbastecimentoLubrificante>> {

    let params = new HttpParams()
    .set('page', page.toString())
    .set('size', size.toString())

    if(filtro) {
      params = params.set('search', filtro);
    }

    if(modulo) {
      params = params.set('modulo', modulo);
    }

    return this.httpClient.get<Page<AbastecimentoLubrificante>>(`${this.configService.getApiUrlRoot()}/abastlubri/`, { params })
  }
  
}
